import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar'
import Manufacturing from '../components/About/Manufacturing'
import Footer from '../components/Layout/Footer'

const ManufacturingPage = () => {
  return (
    <div>
        <NavbarTwo />
        <div className='2xl:pt-[120px] pt-[80px] xl:pt-[110px] lg:pt-[100px]'>
        <Manufacturing />
        <Footer />
        </div>
    </div>
  )
}

export default ManufacturingPage;